import {Button} from '@primer/react'
import {clsx} from 'clsx'
import styles from './ActionBar.module.css'
import {InProgressCommentIndicator} from '../InProgressCommentIndicator'
import {PlusIcon} from '@primer/octicons-react'

export function SimpleAddCommentButton({
  showStartConversation,
  hasDraftComment,
  lineSpacingPreference,
  openStartConversationDialog,
  authorLogin,
  authorAvatarUrl,
}: {
  showStartConversation: boolean
  hasDraftComment: boolean | undefined
  lineSpacingPreference: 'compact' | 'relaxed'
  openStartConversationDialog: () => void
  authorLogin: string
  authorAvatarUrl: string
}) {
  return (
    <>
      {showStartConversation && (
        <div aria-hidden={false} className={clsx('d-flex', 'flex-row', styles.addCommentButton)}>
          <>
            {hasDraftComment ? (
              <Button
                aria-label="Continue comment in progress"
                size="small"
                className={clsx(
                  'py-0',
                  lineSpacingPreference === 'compact'
                    ? styles.addCommentButtonDraftCompact
                    : styles.addCommentButtonDraftRelaxed,
                  styles.actionBarHeight,
                )}
                onClick={openStartConversationDialog}
              >
                <InProgressCommentIndicator
                  lineSpacingPreference={lineSpacingPreference}
                  authorAvatarUrl={authorAvatarUrl}
                  authorLogin={authorLogin}
                />
              </Button>
            ) : (
              <Button
                icon={PlusIcon}
                aria-label="Add comment"
                size="small"
                data-add-comment-button
                className={clsx(
                  'fgColor-muted',
                  'bgColor-accent-emphasis',
                  'borderColor-accent-emphasis',
                  'fgColor-onEmphasis',
                  'px-0',
                  styles.addCommentButtonNew,
                  styles.actionBarHeight,
                  styles.actionBarStartCommentWidth,
                )}
                onClick={openStartConversationDialog}
              />
            )}
          </>
        </div>
      )}
    </>
  )
}

try{ SimpleAddCommentButton.displayName ||= 'SimpleAddCommentButton' } catch {}